"use client"
import { CloseCircleOutlined, InfoCircleOutlined, PrinterOutlined, QuestionCircleOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, FloatButton, Modal, Table, TableColumnsType } from "antd";
import { useState } from "react";

interface HelpModalProps {}
export const HelpModal: React.FC<HelpModalProps> = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = () => {
      setIsModalOpen(true);
    };
  
  
    const handleCancel = () => {
      setIsModalOpen(false);
    };

    const dataSource = [
        {
            key: '1',
            operation: "Lập đơn đơn đăng ký cấp nước",
            operator: "Cán bộ Kinh doanh",
            detail: "Khách hàng đăng ký trực tiếp: Khi khách hàng đến đăng ký dùng nước, cán bộ phụ trách nhập thông tin KH, in đơn đăng ký và phiếu hẹn khảo sát gửi KH. Khách hàng đăng ký Online: Cán bộ phụ trách chỉ dẫn Khách hàng sử dụng App khách hàng để đăng ký cấp nước Online và nhận Phiếu hẹn Online qua App.",
            webOperations: "Lập đơn => In đơn => In phiếu hẹn khảo sát",
            appOperations: "Lập đơn đăng ký online, hoặc Hướng dẫn Khách hàng lập đơn đăng ký Online => Trả Phiếu hẹn khảo sát Online qua App KH.",
        },
        {
            key: '2',
            operation: "Lập đơn đơn đăng ký cấp nước",
            operator: "Cán bộ Kinh doanh",
            detail: "Khách hàng đăng ký trực tiếp: Khi khách hàng đến đăng ký dùng nước, cán bộ phụ trách nhập thông tin KH, in đơn đăng ký và phiếu hẹn khảo sát gửi KH. Khách hàng đăng ký Online: Cán bộ phụ trách chỉ dẫn Khách hàng sử dụng App khách hàng để đăng ký cấp nước Online và nhận Phiếu hẹn Online qua App.",
            webOperations: "Lập đơn => In đơn => In phiếu hẹn khảo sát",
            appOperations: "Lập đơn đăng ký online, hoặc Hướng dẫn Khách hàng lập đơn đăng ký Online => Trả Phiếu hẹn khảo sát Online qua App KH.",
        },
        {
            key: '3',
            operation: "Lập đơn đơn đăng ký cấp nước",
            operator: "Cán bộ Kinh doanh",
            detail: "Khách hàng đăng ký trực tiếp: Khi khách hàng đến đăng ký dùng nước, cán bộ phụ trách nhập thông tin KH, in đơn đăng ký và phiếu hẹn khảo sát gửi KH. Khách hàng đăng ký Online: Cán bộ phụ trách chỉ dẫn Khách hàng sử dụng App khách hàng để đăng ký cấp nước Online và nhận Phiếu hẹn Online qua App.",
            webOperations: "Lập đơn => In đơn => In phiếu hẹn khảo sát",
            appOperations: "Lập đơn đăng ký online, hoặc Hướng dẫn Khách hàng lập đơn đăng ký Online => Trả Phiếu hẹn khảo sát Online qua App KH.",
        },
        {
            key: '4',
            operation: "Lập đơn đơn đăng ký cấp nước",
            operator: "Cán bộ Kinh doanh",
            detail: "Khách hàng đăng ký trực tiếp: Khi khách hàng đến đăng ký dùng nước, cán bộ phụ trách nhập thông tin KH, in đơn đăng ký và phiếu hẹn khảo sát gửi KH. Khách hàng đăng ký Online: Cán bộ phụ trách chỉ dẫn Khách hàng sử dụng App khách hàng để đăng ký cấp nước Online và nhận Phiếu hẹn Online qua App.",
            webOperations: "Lập đơn => In đơn => In phiếu hẹn khảo sát",
            appOperations: "Lập đơn đăng ký online, hoặc Hướng dẫn Khách hàng lập đơn đăng ký Online => Trả Phiếu hẹn khảo sát Online qua App KH.",
        },
        {
            key: '5',
            operation: "Lập đơn đơn đăng ký cấp nước",
            operator: "Cán bộ Kinh doanh",
            detail: "Khách hàng đăng ký trực tiếp: Khi khách hàng đến đăng ký dùng nước, cán bộ phụ trách nhập thông tin KH, in đơn đăng ký và phiếu hẹn khảo sát gửi KH. Khách hàng đăng ký Online: Cán bộ phụ trách chỉ dẫn Khách hàng sử dụng App khách hàng để đăng ký cấp nước Online và nhận Phiếu hẹn Online qua App.",
            webOperations: "Lập đơn => In đơn => In phiếu hẹn khảo sát",
            appOperations: "Lập đơn đăng ký online, hoặc Hướng dẫn Khách hàng lập đơn đăng ký Online => Trả Phiếu hẹn khảo sát Online qua App KH.",
        },
        {
            key: '6',
            operation: "Lập đơn đơn đăng ký cấp nước",
            operator: "Cán bộ Kinh doanh",
            detail: "Khách hàng đăng ký trực tiếp: Khi khách hàng đến đăng ký dùng nước, cán bộ phụ trách nhập thông tin KH, in đơn đăng ký và phiếu hẹn khảo sát gửi KH. Khách hàng đăng ký Online: Cán bộ phụ trách chỉ dẫn Khách hàng sử dụng App khách hàng để đăng ký cấp nước Online và nhận Phiếu hẹn Online qua App.",
            webOperations: "Lập đơn => In đơn => In phiếu hẹn khảo sát",
            appOperations: "Lập đơn đăng ký online, hoặc Hướng dẫn Khách hàng lập đơn đăng ký Online => Trả Phiếu hẹn khảo sát Online qua App KH.",
        },
      ];
      
      const columns: TableColumnsType = [
        {
            title: 'STT',
            dataIndex: 'key',
            key: 'key',
            align: "center"
        },
        {
            title: 'Nghiệp vụ',
            dataIndex: 'operation',
            key: 'operation',
            align: "center"
        },
        {
            title: 'Nội dung',
            children: [
                {
                    title: "Phụ trách",
                    dataIndex: "operator",
                    key: "operator",
                    width: 80,
                    align: "center"
                },
                {
                    title: "Chi tiết",
                    dataIndex: "detail",
                    key: "detail",
                    align: "center"
                }
            ]
        },
        {
            title: 'Thao tác trên Phần mềm',
            children: [
                {
                    title: "Web quản lý",
                    dataIndex: "webOperations",
                    key: "webOperations",
                    align: "center"
                },
                {
                    title: "Web quản lý",
                    dataIndex: "appOperations",
                    key: "appOperations",
                    align: "center"
                }
            ]
        },
      ];
    return (
        <div>
            <FloatButton icon={<QuestionCircleOutlined />} type="primary" onClick={showModal}/>
            <Modal open={isModalOpen} onCancel={handleCancel} width={1400} footer={[
                <Button key="edit" icon={<InfoCircleOutlined />} style={{ background: "#0B6D8E", color: "white"}} onClick={handleCancel} >
                    Chỉnh sửa
                </Button>,
                <Button key="print" icon={<PrinterOutlined />} style={{ background: "#00B050", color: "white"}} onClick={handleCancel} >
                    In ấn
                </Button>,
                <Button key="close" icon={<CloseCircleOutlined />} style={{ background: "#FF0000", color: "white"}} onClick={handleCancel} >
                    Đóng
                </Button>,
            ]}>
                <div className="absolute top-4 left-4 flex flex-row items-center select-none">
                    <img
                        src="/images/dashboard/question.png"
                        alt="Chỉ dẫn nghiệp vụ"
                        width={30}
                        height={30}
                    />
                    <p className="ml-2 text-lg font-semibold">Chỉ dẫn nghiệp vụ</p>
                </div>
                <div className="flex flex-row w-full items-center justify-center select-none">
                    <img
                        src="/images/layout/sidebar/customer.png"
                        alt="Quản lý khách hàng"
                        width={30}
                        height={30}
                    />
                    <p className="ml-2 text-lg font-bold text-primary">Quản lý khách hàng</p>
                </div>
                <div className="my-4">
                    <ConfigProvider theme={{
                        components: {
                            Table: {
                                headerBg: "#052F61",
                                headerSplitColor: "white",
                                headerColor: "white",
                                cellPaddingBlock: 2,
                                cellPaddingInline: 8
                            }
                        }
                    }}>
                        <Table rowHoverable={false} dataSource={dataSource} columns={columns} pagination={false} bordered={true} rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}/>
                    </ConfigProvider>
                </div>
                
            </Modal>
        </div>
    )
}